import { render } from "./PosLeftbarTestOld.vue?vue&type=template&id=3c8a7ae6&scoped=true"
import script from "./PosLeftbarTestOld.vue?vue&type=script&lang=js"
export * from "./PosLeftbarTestOld.vue?vue&type=script&lang=js"

import "./PosLeftbarTestOld.vue?vue&type=style&index=0&id=3c8a7ae6&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8a7ae6"]])

export default __exports__